module.exports = __webpack_public_path__ + "img/qr-wx-xcx.08efcafa.jpg";